// extracted by mini-css-extract-plugin
export default {"btn_zamknij":"DodajRealizacjeBtn_btn_zamknij__wdhFI"};